const DpoMailObecnyEmail = {
    init: function () {
        $(document)
            .on("modal.button.miniform.close.pre", function (e, data) {
                if (true !== data.hasOwnProperty("miniformId")
                    || 111 !== parseInt(data["miniformId"])
                ) {
                    return;
                }

                const predmet = $("#modal-predmet").val();
                const komentar = $("#modal-komentar").val();

                if (predmet && komentar) {
                    Promise.all([
                        DpoMailObecnyEmail.disableButtons(),
                        DpoMailObecnyEmail.odeslatEmail(predmet, komentar)
                    ]).then(() => {
                        setTimeout(function () {
                            window.location.reload();
                        }, 1500);
                    });
                }
            });
    },

    disableButtons: function () {
        return new Promise((resolve) => {
            const butnicky = $(".btn");
            $(butnicky).each((i, btn) => {
                $(btn).attr("disabled", true).prop("disabled", true);
            });

            resolve("buttons.disabed");
        });
    },

    odeslatEmail: function (predmet, komentar) {
        return new Promise((resolve) => {
            let url = window.location.protocol + "//" + window.location.host;
            url += "/ajax/mail/odeslat";

            const sekceId = $('#idSection').val();
            if (!sekceId) {
                return;
            }
            url += '/' + sekceId;

            const zadostId = $('#idItem').val();
            if (!zadostId) {
                return;
            }
            url += '/' + zadostId;

            $.ajax({
                type: "post",
                url: url,
                data: {"predmet": predmet, "komentar": komentar, "_ch": $("#_ch").val()},
                dataType: "json",
                global: true,
                beforeSend: function () {
                    Lemo_Alert.closeAll();
                },
                complete: function () {
                    resolve("common.email");
                },
                success: function (r) {
                    if (r.hasOwnProperty("messages")) {
                        Lemo_Alert.addMany(r["messages"]);
                    }
                },
                error: function () {
                    Lemo_Alert.addDanger("Odeslání emailu selhalo.", "odeslaniEmailuError");
                }
            });
        });
    }
}

$(document).ready(function () {
    DpoMailObecnyEmail.init();
});
